export default "__VITE_ASSET__21fce997__"